import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Map } from 'leaflet';
import { ToastrService } from 'ngx-toastr';
import { FlagService } from '../../flag/flag.service';
import { ViewerWindowService } from '../../shared/viewer.window.service';
import { AddFlagComponent } from '../add.flag/add.flag.component';
import { EditFlagComponent } from '../edit.flag/edit.flag.component';
import { PictureViewerComponent } from '../picture-viewer/picture-viewer.component';

@Component({
  selector: 'app-inspection-popup',
  templateUrl: './inspection-gallery-popup.component.html',
  styleUrls: ['./inspection-gallery-popup.component.scss'],
})
export class InspectionGalleryPopupComponent implements OnInit {
  constructor(
    private toastr: ToastrService,
    private flagService: FlagService,
    private opener: ViewerWindowService,
    private cdr: ChangeDetectorRef,
  ) {}

  currentPicture;
  map: Map = null;
  showUnpinnedFlags = false;

  @ViewChild('addFlagModal', { static: false }) addFlagModal: AddFlagComponent;
  @ViewChild('editFlagModal', { static: false }) editFlagModal: EditFlagComponent;
  @ViewChild('pictureViewer', { static: false }) pictureViewer: PictureViewerComponent;

  pictures = [];

  placeholderFlag;
  showMessage = false;

  ngOnInit() {
    this.opener.getPictures().subscribe(pictures => {
      this.pictures = pictures;
    });

    this.opener.getSelectedImage().subscribe(selectedId => {
      this.currentPicture = this.pictures?.find(p => p.id == selectedId);
      this.cdr.detectChanges();
    });

    this.opener.setReady();
  }

  getFlags() {
    return (
      this.currentPicture?.answer?.flags.filter(flag => {
        if (flag.picture) {
          return flag.picture.key === this.currentPicture.key;
        }
      }) || []
    );
  }

  moveFlag(event) {
    this.opener.moveFlag(event);
  }

  addFlag(coords) {
    this.placeholderFlag = coords;
    this.addFlagModal.show({
      answer: this.currentPicture.answer,
      picture: this.currentPicture,
      coords,
      confirmed: () => {
        this.placeholderFlag = undefined;
        this.opener.updateAnswer({ answer: this.currentPicture.answer });
        this.toastr.success('Flag Saved');
      },
      canceled: () => {
        this.placeholderFlag = undefined;
      },
    });
  }

  editFlag({ flag, clientX, clientY }) {
    const answer = this.currentPicture.answer;
    this.editFlagModal.show({
      flag,
      answer,
      coords: { clientX, clientY },
      changed: newFlag => {
        this.editFlagChanged(newFlag);
        this.opener.updateAnswer({ answer });
        this.toastr.success('Flag Saved');
      },
      deleted: () => {
        this.editFlagDeleted(flag);
        this.opener.updateAnswer({ answer });
        this.toastr.success('Flag Removed');
      },
    });
  }

  editFlagChanged(newFlag) {
    this.currentPicture.answer.flags = this.currentPicture.answer.flags.map(f => {
      if (f.id === newFlag.id) {
        return newFlag;
      }
      return f;
    });
  }

  editFlagDeleted(flag) {
    this.currentPicture.answer.flags.splice(
      this.currentPicture.answer.flags.findIndex(f => f.id === flag.id),
      1,
    );
  }

  unpinnedFlagsCount() {
    return this.currentPicture?.answer?.flags?.filter(flag => !flag.pictureId).length || 0;
  }

  formattedDateTime(date) {
    const obj = new Date(date);
    return `${obj.getMonth() + 1}/${obj.getDate()}/${obj.getFullYear()} ${obj.getHours() < 10 ? '0' : ''}${obj.getHours()}:${obj.getMinutes() < 10 ? '0' : ''}${obj.getMinutes()}`;
  }

  next() {
    this.opener.navigatePicture('next');
  }

  prev() {
    this.opener.navigatePicture('prev');
  }

  get hasNext() {
    const currentIndex = this.pictures.findIndex(p => p.id == this.currentPicture.id);
    return currentIndex < this.pictures.length - 1;
  }

  get hasPrev() {
    const currentIndex = this.pictures.findIndex(p => p.id == this.currentPicture.id);
    return currentIndex > 0;
  }

  toggleFlags() {
    this.showUnpinnedFlags = !this.showUnpinnedFlags;
    this.cdr.detectChanges();
  }

  closeFlags() {
    this.showUnpinnedFlags = null;
  }

  onMapReady(map: Map) {
    this.map = map;
  }

  async pinFlag(flag) {
    const coord = this.pictureViewer.imgSize;
    const x = coord[0] / 2;
    const y = coord[1] / 2;

    this.opener.pinFlag({ flag, x, y });
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.target === document.body) {
      switch (event.key) {
        case 'ArrowLeft':
          this.prev();
          break;
        case 'ArrowRight':
          this.next();
          break;
        case 'Escape':
          this.closeFlags();
          break;
      }
    }
  }
}
